import { useNavigate } from 'react-router-dom'
import Modal from 'components/Modal'
import { DialogFooter } from '@center/ui-kit'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { InputAdornment, TextField, useTheme, Typography } from '@mui/material'
import { gql, useLazyQuery } from '@apollo/client'
import { yupResolver } from '@hookform/resolvers/yup'
import { object, string } from 'yup'

const OPERATION_FIND_BY_EMAIL = gql`
    query FindContactByEmail($email: String!) {
        contact: findContactByEmail(email: $email) {
            sf_id
        }
    }
`

const CheckEmail = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClose = () => {
    navigate({ pathname: '..' })
  }

  const validationEmail = object({
    email: string()
      .email(t('login.error.email_format'))
      .required(t('login.error.required'))
      .transform((value) => value?.toLowerCase().trim()),
  })

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(validationEmail),
  })

  const [checkEmail, {error}] = useLazyQuery(OPERATION_FIND_BY_EMAIL)

  const onSubmit = async ({ email }) => {
      const { data, error } = await checkEmail({
        variables: { email },
      })
      if (!error) {
        const contact = data?.contact
        if (contact) {
          navigate({pathname: `/contacts/edit/${contact.sf_id}`})
        } else navigate({ pathname : `/contacts/edit/${email}`})
      }
  }

  return (
    <Modal
      icon={<i className="fa-solid fa-plus" />}
      minWidth='400px'
      title={'Nouvel utilisateur'}
      onClose={() => handleClose()}
    >
      <TextField
        sx={{
          fontStyle: 'italic',
          background: 'white',
          borderRadius: '12px',
          padding: '0 8px',
        }}
        helperText={errors.email?.message}
        error={errors.email?.message ? true : false}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <i
                className={'fa-regular fa-paper-plane'}
                style={{ color: theme.palette.primary.main }}
              />
            </InputAdornment>
          ),
        }}
        {...register('email')}
        placeholder="Email"
      />
      {
        !!error && (<Typography color={'error'}>{t('auth.admin.check_email_error')}</Typography>)
      }
      <DialogFooter
        variant="text"
        onClose={() => handleClose()}
        closeLabel={t('ui_elements.form_cancel')}
        closeType="text"
        onConfirm={handleSubmit(onSubmit)}
        confirmLabel={t('ui_elements.form_validate')}
        confirmType="submit"
      />
    </Modal>
  )
}

export default CheckEmail
